import { TextField as MuiTextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { formatUsPhoneDisplay } from "../../utils/phoneUtils";

const PhoneField = ({ name, label, required, disabled, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <MuiTextField
          {...field}
          value={formatUsPhoneDisplay(field.value)}
          onChange={(e) => field.onChange(formatUsPhoneDisplay(e.target.value))}
          label={label}
          variant="outlined"
          fullWidth
          type="tel"
          placeholder="(555) 123-4567"
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          required={!!required}
          disabled={!!disabled}
          {...rest}
        />
      )}
    />
  );
};

PhoneField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default PhoneField;
